import F7Event  from '../app/events/f7_event';
import logEvent from '../app/events/amplitude_log_event';
import React    from 'react';
import ReactDOM from 'react-dom';


export default function renderAsPopup(Component, eventName) {
  if (eventName)
    logEvent(eventName);

  return (props = {}) => {
    const { tabletFullScreen = true } = props;

    const render = (
      <PopupContainer tabletFullScreen={tabletFullScreen}>
        {
          ({ close }) => (
            <Component {...props} popup={{ close }}/>
          )
        }
      </PopupContainer>
    );

    ReactDOM.render(render, getContainer(), () => {
      // Because our current popup implementation, f7 never shows the backdrop by adding
      // the `backdrop-in` class to it. We need to do that. But, we are only going to do
      // it when the width of the screen is >= 630px. Because when it's less than that, f7
      // shows the popup in full screen. So, there is no need to show it and we avoid a
      // flickering in mobile.
      const shouldShowBackdrop = document.documentElement.clientWidth >= 630;
      const popupBackdrop      = document.querySelector('.popup-backdrop');
      if (shouldShowBackdrop && popupBackdrop)
        popupBackdrop.classList.add('backdrop-in');
    });
  };
}

function getContainer() {
  const hasContainer = document.querySelector('div#popup');
  if (hasContainer)
    return hasContainer;
  else {
    const container = document.createElement('div');
    container.id    = 'popup';
    document.querySelector('body').appendChild(container);
    return container;
  }
}


class PopupContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.popupEl = React.createRef();
    this.popup   = null;
    this.close   = this.close.bind(this);
  }

  componentDidMount() {
    if (this.popupEl) {
      this.popupEl.current.dispatchEvent(new F7Event(app => {
        this.popup = app.popup.open(this.popupEl.current);
      }));
    }
  }

  close() {
    const unmounted = ReactDOM.unmountComponentAtNode(getContainer());
    if (unmounted) {
      const popupBackdrop = document.querySelector('.popup-backdrop');
      if (popupBackdrop)
        popupBackdrop.classList.remove('backdrop-in');
    }
  }

  render() {
    const { children }         = this.props;
    const { tabletFullScreen } = this.props;
    const className            = tabletFullScreen ? 'popup-tablet-fullscreen' : '';
    const render               = children({ close: this.close });
    return (
      <div className={`popup modal-in ${className}`} ref={this.popupEl}>
        {render}
      </div>
    );
  }
}
